import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=22e1a070&scoped=true"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"
import style0 from "./BaseChart.vue?vue&type=style&index=0&id=22e1a070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1a070",
  null
  
)

export default component.exports